<div class="container-fluid">
    <div class="row">
        <div class="col-xl-12">
            <h1 class="page-hd">Document Verification <i class="fa fa-angle-right hd-icon" aria-hidden="true"></i>
                Edit Verify Document Form</h1>
            <div class="content-wrap">
                <h3 class="form-hd2">Fill the form below to edit document.</h3>
                <h4><span class="color-red">Reason for Edit:-</span> {{editReason}}</h4>

                <form [formGroup]="editForm">
                    <div class="row">

                        <div class="col-md-3">
                            <div class="form-group input-group-lg">
                                <label for="firstName" class="form-label">First Name</label>
                                <input value={{firstName}} placeholder="firstname" id="firstname"
                                    formControlName="firstname" class="form-control form-input"
                                    [(ngModel)]="editRequest.first_name"
                                    [ngClass]="{'is-invalid': submitted && f.firstname.errors }">
                                    <div *ngIf="submitted && f.firstname.errors" class="invalid-feedback">
                                        <div *ngIf="f.firstname.errors.required">First name cannot be empty.</div>
                                    </div>
                            </div>
                        </div>
                        <div class="col-md-3">
                            <div class="form-group input-group-lg">
                                <label for="lastName" class="form-label">Last Name</label>
                                <input value={{lastName}} placeholder="lastname" id="lastname"
                                    formControlName="lastname" class="form-control form-input"
                                    [(ngModel)]="editRequest.last_name"
                                    [ngClass]="{'is-invalid': submitted && f.lastname.errors }">
                                    <div *ngIf="submitted && f.lastname.errors" class="invalid-feedback">
                                        <div *ngIf="f.lastname.errors.required">First name cannot be empty.</div>
                                    </div>
                            </div>
                        </div>
                        <div class="col-md-3">
                            <div class="form-group input-group-lg">
                                <label for="enrollno" class="form-label">Seat Number</label>
                                <input value={{seatNumber}} placeholder="Enter Seat No." formControlName="enrollno"
                                    class="form-control form-input" [(ngModel)]="editRequest.enroll_no"
                                    [ngClass]="{'is-invalid': submitted && f.enrollno.errors }">
                                    <div *ngIf="submitted && f.enrollno.errors" class="invalid-feedback">
                                        <div *ngIf="f.enrollno.errors.required">Seat number cannot be empty.</div>
                                    </div>
                            </div>
                        </div>

                    </div>
                    <div class="row">
                        <div class="col-md-3">
                            <div class="form-group input-group-lg">
                                <label for="stream" class="form-label">Stream</label>
                                <select formControlName="streamid" class="form-control form-input" id="streamid"
                                    placeholder="Select Your Stream" value="streamId" [(ngModel)]="editRequest.stream_id"
                                    [ngClass]="{'is-invalid': submitted && f.streamid.errors }"
                                    (change)='getBranAndStream($event.target.value)'>
                                    <!-- (change)='getBranAndSem($event.target.value)'
                                        <option [ngValue]="streamId">{{prevStreamName}}</option> -->
                                    <option value="" disabled> Please select Stream </option>
                                    <option *ngFor="let stream of streamDropDown" [ngValue]="stream.id"
                                    [selected]="stream.id == streamId">
                                        {{stream.streamName}}</option>
                                </select>
                                <div *ngIf="submitted && f.streamid.errors" class="invalid-feedback">
                                    <div *ngIf="f.streamid.errors.required">Stream cannot be empty.</div>
                                </div>
                            </div>
                        </div>

                        <div class="col-md-3">
                            <div class="form-group input-group-lg">
                                <label for="stream" class="form-label">Branch</label>
                                <select formControlName="branchid" class="form-control form-input" id="branchid"
                                    placeholder="Select Your Branch" value="branchId" [(ngModel)]="editRequest.branch_id"
                                    [ngClass]="{'is-invalid': submitted && f.branchid.errors }">
                                    <!-- (change)='getBranAndSem($event.target.value)'
                                        <option [ngValue]="streamId">{{prevStreamName}}</option> -->
                                    <option value="" > Please select Branch </option>
                                    <option *ngFor="let branch of branchDropDown" [ngValue]="branch.id"
                                    [selected]="branch.id == branchId">
                                        {{branch.branchName}}</option>
                                </select>
                                <div *ngIf="submitted && f.branchid.errors" class="invalid-feedback">
                                    <div *ngIf="f.branchid.errors.required">Branch cannot be empty.</div>
                                </div>
                            </div>
                        </div>

                        <div class="col-md-3">
                            <div class="form-group input-group-lg">
                                <label for="semid" class="form-label">Semester</label>
                                <select formControlName="semid" class="form-control form-input" id="semid"
                                    placeholder="Select Your Semester" value="semId" [(ngModel)]="editRequest.semid"
                                    [ngClass]="{'is-invalid': submitted && f.semid.errors }">
                                    <!-- (change)='getBranAndSem($event.target.value)'
                                        <option [ngValue]="streamId">{{prevStreamName}}</option> -->
                                    <option value="" > Please select Semester </option>
                                    <option *ngFor="let semester of semDropDown" [ngValue]="semester.id"
                                    [selected]="semester.id == semId">
                                        {{semester.semester}}</option>
                                </select>
                                <div *ngIf="submitted && f.semid.errors" class="invalid-feedback">
                                    <div *ngIf="f.semid.errors.required">Semester cannot be empty.</div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-md-3">
                            <div class="form-group input-group-lg">
                                <label for="document" class="form-label">Document</label>
                                <select formControlName="docname" class="form-control form-input" id="docname"
                                [(ngModel)]="editRequest.doc_id" [ngClass]="{'is-invalid': submitted && f.docname.errors }">
                                    <option value="" disabled> Please select Document </option>
                                    <option *ngFor="let document of documentDropDown" [ngValue]="document.id"
                                    [selected]="document.id == docId">
                                        {{document.documentName}}</option>
                                </select>
                                <div *ngIf="submitted && f.docname.errors" class="invalid-feedback">
                                    <div *ngIf="f.docname.errors.required">Document cannot be empty.</div>
                                </div>
                            </div>
                        </div>

                        <div class="col-md-3">
                            <div class="form-group input-group-lg">
                                <label for="requesttype" class="form-label">Request Type</label>
                                <select formControlName="requesttype" class="form-control form-input"
                                    id="requesttype" [(ngModel)]="editRequest.request_type_id"
                                    [ngClass]="{'is-invalid': submitted && f.requesttype.errors }">
                                    <option value="" disabled> Please select Request Type </option>
                                    <option *ngFor="let request of RequestTypeDropDown" [ngValue]="request.id"
                                    [selected]="request.id == requestId">
                                        {{request.requestType}}</option>
                                </select>
                                <div *ngIf="submitted && f.requesttype.errors" class="invalid-feedback">
                                    <div *ngIf="f.requesttype.errors.required">Request type cannot be empty.</div>
                                </div>
                            </div>
                        </div>

                        <div class="col-md-3">
                            <div class="form-group input-group-lg">
                                <label for="collegenameid" class="form-label">College Name</label>
                                <select formControlName="collegenameid" class="form-control form-input"
                                    id="collegenameid" [(ngModel)]="editRequest.college_name_id"
                                    [ngClass]="{'is-invalid': submitted && f.collegenameid.errors }">
                                    <option value="" disabled> Please select College </option>
                                    <option *ngFor="let college of collegeDropDown" [ngValue]="college.id"
                                    [selected]="college.id == collegeId">
                                        {{college.collegeName}}</option>

                                </select>
                                <div *ngIf="submitted && f.collegenameid.errors" class="invalid-feedback">
                                    <div *ngIf="f.collegenameid.errors.required">Request type cannot be empty.</div>
                                </div>
                            </div>
                        </div>

                    </div>
                    <div class="row">

                        <div class="col-md-3">
                            <div class="form-group input-group-lg">
                                <label for="passingYear" class="form-label">Year of Passing</label>
                                <mat-form-field>
                                    <input matInput [matDatepicker]="dp" [formControl]="date" autocomplete="off"
                                        placeholder="Select Month and Year" formControlName="yearAndMonthSelect" [matDatepickerFilter]=dateFilter >
                                    <mat-datepicker-toggle matSuffix [for]="dp" ></mat-datepicker-toggle>
                                    <mat-datepicker #dp startView="multi-year" 
                                        (yearSelected)="chosenYearHandler($event)"
                                        (monthSelected)="chosenMonthHandler($event, dp)"
                                        panelClass="example-month-picker">
                                    </mat-datepicker>
                                </mat-form-field>
                            </div>
                        </div>

                       <!--  <div class="col-md-3">
                            <div class="form-group input-group-lg">
                                <label for="altemail" class="form-label">Alternate EmailID <span style="color:#21B4F3;font-size:100% ;"> Max 5 comma separated email ids allowed.</span></label>
                                <input placeholder="Enter EmailId" formControlName="altemail" 
                                    class="form-control form-input"  (change)="inputChanged($event)" [(ngModel)]="editRequest.alt_email">
                                    <div *ngIf="altEmailLengthCheck">
                                        <div style="color:red;">Only upto 5 emails permitted.</div>
                                    </div>
                                    <div *ngIf="altEmailValidation">
                                        <div style="color:red;">Please enter correct email ids.</div>
                                    </div>
                            </div>
                        </div>  -->

                        <div class="col-md-3">
                            <div class="form-group input-group-lg">
                                <label for="uploaddocpath" class="form-label">Upload Document<span style="color:#f32f21;font-size:15px ;"> All semester marksheets should be uploaded in one PDF (upto 5 MB).</span></label>
                                <input formControlName="uploaddocpath" type="file"
                                    class="form-control form-input border-none"
                                    accept=".png,.jpg,.jpeg,.tiff,.pdf" id="uploaddocpath"
                                    (change)="catchEvent($event.target.files)" 
                                    
                                    [ngClass]="{'is-invalid': submitted && f.uploaddocpath.errors }">
                                        <div *ngIf="fileSizeErr">
                                            <p style="color:#dc3545;font-size:100% ;">File size should be below 5MB.</p>
                                        </div>
                                <button [disabled]="newFileCheck" class="button bg-theme color-white" (click)="viewDocument()">View Document</button>
                                <div *ngIf="submitted && f.uploaddocpath.errors" class="invalid-feedback">
                                    <div *ngIf="f.uploaddocpath.errors.required">Document upload cannot be empty.</div>
                                </div>
                            </div>
                        </div>
                        <input placeholder="filepath" formControlName="filepath" hidden>

                        <div class="col-md-3" >
                            <div class="form-group input-group-lg">
                                <label for="college" class="form-label">Verification Purpose</label>
                                <select formControlName="embassyid" class="form-control form-input"
                                
                                    id="embassyid" (change)="getembassylist($event.target.value)" [(ngModel)]="editRequest.embassyid">
                                    <option value="" disabled selected>Please select verification Purpose</option>
                                    <option *ngFor="let embassy of EmbassyDropDown" [ngValue]="embassy.id">
                                        {{ embassy.embassyName }}</option>

                                </select>
                            </div>
                        </div>

                    </div>

                    <div class="row">



                        <div class="col-md-3">

                            
                            <div class="form-group input-group-lg">
                                <label for="embassyname" class="form-label">Embassy Name</label>
                                <input placeholder="embassy name"  [readonly]="embassyidDisabled"
                                    formControlName="embassyname"  [(ngModel)]="editRequest.embassyname" class="form-control form-input">
                                
                            </div>
                          </div>
                          
                          <div class="col-md-3">
                            <div class="form-group input-group-lg">
                              <label for="embassyaddress" class="form-label">Embassy Address</label>
                              <input
                                placeholder="Embassy Address"
                                formControlName="embassyaddress" [readonly]="embassyidDisabled" [(ngModel)]="editRequest.embassyaddress"

                                class="form-control form-input"/>

                            </div>
                          </div>
                    </div>
                    <div *ngIf="fillSemBranch">
                        <p style="color: red;">Please select Branch and Semester to proceed.</p>
                    </div>
                    <div *ngIf="fillembassyname">
                        <p style="color: red;">Please select embassy name and embassy address.</p>
                    </div>
                    <button class="proceed-btn bg-theme" (click)="onSubmit()">Save</button>

                </form>
            </div>
        </div>
    </div>
</div>


<ng-template #showModalBoxImage let-modal id="previewDocModel">
    <div class="modal-content">
        <div class="modal-header bg-theme">
            <h5 class="modal-title" id="viewModalLabel">Preview Document</h5>

            <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
                <span aria-hidden="true">&times;</span>
            </button>
        </div>
      
        <div class="modal-body">
            <div class="row">
              <div class="col-md-12">
                <!-- <button   (click)="showmagnify()">Magnify</button>   -->
                <!-- <div *ngIf="!isVrPdf && !noImage1">
                  <app-magnify  [imageId]="imgname" [ImageURL]="document_path"> </app-magnify>
                </div> -->
              
                <p class="doc-txt">To be verified</p>
                <div *ngIf="isVrPdf">
                  <div class="ng-star-inserted22">
                    <!-- <pdf-viewer [src]="src" [zoom]="1"></pdf-viewer> -->
                    <div class="img-magnifier-container">
                      <pdf-viewer [src]="src" [zoom]="1"></pdf-viewer>
                    </div>
                  </div>
                  <button class="new-tab-btn" (click)="openPdf()">Open Doc in Browser</button>
                </div>
                <div *ngIf="isVrImage">
                  <!-- <img src={{upload_doc_path}} class="doc-img" (click)="showLightbox(0)" loading="lazy"> -->
                  <div class="img-magnifier-container">
                    <img src={{document_path}}  class="doc-img" id="uploadImg1"  (click)="showLightbox(0)" loading="lazy">
                  </div>
                </div>
              </div>
            </div>
          </div>

    </div>
</ng-template>


<ng-template #showModalBox class="modal fade " id="successModal" tabindex="-1" role="dialog" let-c="close"
    let-d="dismiss" aria-labelledby="resetPasswordModalLabel" aria-hidden="false">

    <div class="modal-content">
        <div class="modal-header success-modal-header">
            <h5 class="modal-title icon-title" id="resetPasswordModalLabel">
                <span class="icon-wrap bg-theme"><img src="assets/images/thumb-up.png" class="fa-icon-modal"
                        alt="img"></span>
            </h5>
        </div>
        <div class="modal-body">
            <div class="row">
                <div class="col-md-12">
                    <h3 class="success-text">Success</h3>
                    <p class="reset-hd2">{{strMessage}}</p>
                </div>
            </div>
            <button class="approve-modal-btn2 bg-theme mr-auto" data-dismiss="modal" (click)="refresh()">Done</button>
        </div>
    </div>

</ng-template>